var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "aaGamePage page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "game-box gap-10"
  }, [_c('div', {
    staticClass: "game-top-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', [_c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.gameState.score))])])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count"
  }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.leftTime)))]), _c('div', {
    staticClass: "time-text"
  }, [_vm._v(_vm._s(_vm.$lang('Award and reset after countdown.')))])])]), _c('div', [_c('div', {
    staticClass: "bg-white/80 rounded relative",
    on: {
      "click": _vm.viewRank
    }
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "width": "18",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.prizePool))])])])]), _c('div', {
    ref: "gameCenterBox",
    staticClass: "game-center-box relative flex flex-1"
  }, [_c('canvas', {
    ref: "canvasRef",
    staticClass: "w-full h-full object-cover",
    attrs: {
      "width": _vm.CANVAS_WIDTH,
      "height": _vm.CANVAS_HEIGHT
    },
    on: {
      "click": _vm.handleShoot
    }
  })])])]), _c('pop-game-warn-prompt', {
    attrs: {
      "show": _vm.popOpenMobileShow,
      "message": _vm.$lang(`Please open this page on your mobile phone.`),
      "btnConfirmText": _vm.$lang('Back')
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenMobileShow = $event;
      },
      "confirm": function ($event) {
        return _vm.$router.back();
      }
    }
  }), _c('pop-game-start-prompt', {
    attrs: {
      "show": _vm.popStartShow,
      "message": _vm.$lang(`<li>Earn rewards by playing.</li>
<li>The higher your rank, the greater your reward.</li>
<li>Play multiple times within the countdown. Only your highest score will count for ranking.</li>
<li>All players will reset and start over once the countdown ends.</li>`)
    },
    on: {
      "update:show": function ($event) {
        _vm.popStartShow = $event;
      },
      "confirm": function ($event) {
        return _vm.initLevel(1);
      }
    }
  }), _c('pop-game-win-prompt', {
    attrs: {
      "show": _vm.popWinShow,
      "title": _vm.$lang('Congratulations'),
      "message": _vm.$lang(`You completed the level ${_vm.gameState.level}`),
      "nextLevel": _vm.gameState.level + 1,
      "nextBtnText": _vm.nextBtnText
    },
    on: {
      "update:show": function ($event) {
        _vm.popWinShow = $event;
      },
      "confirm": function ($event) {
        return _vm.initLevel(_vm.gameState.level + 1);
      }
    }
  }), _c('pop-game-lost-prompt', {
    attrs: {
      "show": _vm.popLostShow,
      "title": _vm.$lang('Game over'),
      "message": _vm.$lang('Going beyond the limit, game over.'),
      "cancelText": _vm.revives > 0 ? _vm.$lang('Give up') : _vm.$lang('Restart (Score Resets)'),
      "confirmText": _vm.revives > 0 ? _vm.$lang(`Revive (${_vm.revives}/${_vm.maxRevives})`) : _vm.$lang('Restart')
    },
    on: {
      "update:show": function ($event) {
        _vm.popLostShow = $event;
      },
      "cancel": _vm.handleCancel,
      "confirm": function ($event) {
        return _vm.handleConfirm();
      }
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-rank', {
    attrs: {
      "gameType": 'aaGame',
      "show": _vm.popGameRankShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRankShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };